import { render, staticRenderFns } from "./TfacIndividualStudentFile.vue?vue&type=template&id=3f1c1812"
import script from "./TfacIndividualStudentFile.vue?vue&type=script&lang=js"
export * from "./TfacIndividualStudentFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports